import { type FolderListItem, type FolderParent } from "../types/folder.types.ts"

interface FolderPath {
  crumbs: FolderParent[]
  pendingParentId: string | null
  isComplete: boolean
}

interface FolderAncestry {
  ancestors: FolderParent[]
  isComplete: boolean
}

const ROOT_FOLDER_PATH: FolderPath = { crumbs: [], pendingParentId: null, isComplete: true }

const openFolderPath = (path: FolderPath, folder: FolderListItem): FolderPath => {
  const crumb = { id: folder.id, name: folder.name }
  if (!folder.parent) {
    return { crumbs: [crumb], pendingParentId: null, isComplete: true }
  }
  const parentIndex = path.crumbs.findIndex((entry) => entry.id === folder.parent)
  if (parentIndex >= 0) {
    return { ...path, crumbs: [...path.crumbs.slice(0, parentIndex + 1), crumb] }
  }
  return { crumbs: [crumb], pendingParentId: folder.parent, isComplete: false }
}

const truncateFolderPath = (path: FolderPath, depth: number): FolderPath =>
  depth === 0 ? ROOT_FOLDER_PATH : { ...path, crumbs: path.crumbs.slice(0, depth) }

const withAncestors = (path: FolderPath, ancestry: FolderAncestry): FolderPath => ({
  crumbs: [...ancestry.ancestors, ...path.crumbs],
  pendingParentId: null,
  isComplete: ancestry.isComplete
})

export { openFolderPath, ROOT_FOLDER_PATH, truncateFolderPath, withAncestors }
export type { FolderAncestry, FolderPath }
